import React, { createContext, useState, useContext } from 'react';
import { EventEmitter } from 'events';

export const EventEmitterContext = createContext(new EventEmitter());

export function EventEmitterProvider({ children }) {
    const [ee] = useState(() => new EventEmitter());

    return <EventEmitterContext.Provider value={ee}>{children}</EventEmitterContext.Provider>;
}

export function useEventEmitter() {
    return useContext(EventEmitterContext);
}
